/**
 * AppShell — wraps all protected pages with sidebar + topbar.
 * Also mounts NavigationBlocker to intercept dirty-form navigations.
 */
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import NavigationBlocker from './NavigationBlocker';

interface AppShellProps {
  children: React.ReactNode;
}

export default function AppShell({ children }: AppShellProps) {
  return (
    <div className="min-h-screen bg-surface-50">
      {/* Intercepts React Router navigations when form is dirty */}
      <NavigationBlocker />

      <Sidebar />
      <Topbar />
      <main className="ml-64 pt-16">
        <div className="p-6">
          {children}
        </div>
      </main>
    </div>
  );
}
